const STORAGE_KEY = 'evplanner.cookie_consent';
export const CONSENT_VERSION = 'v1';

export function readCookieConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_err) {
    return null;
  }
}

export function writeCookieConsent(consent) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      ...consent,
      version: CONSENT_VERSION,
      updatedAt: new Date().toISOString(),
    }),
  );
}

export function hasValidConsent() {
  const stored = readCookieConsent();
  return stored?.version === CONSENT_VERSION && Boolean(stored?.decidedAt);
}

export const defaultPreferences = () => ({
  necessary: true,
  analytics: false,
  marketing: false,
});
